import { t } from '@lingui/core/macro';

export const CLOSE_TEXT = (): string => t`Close`;
export const DELETE_REPLY_TEXT = (): string => t`Delete reply`;
export const SUBMIT_REPLY_TEXT = (): string => t`Submit reply`;
export const SKIP_TEXT = (): string => t`Skip`;
export const OK_TEXT = (): string => t`OK`;
